import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import OriginalGoodsItem from "../../components/store/OriginalGoodsItem";
import OriginalItem from '../../components/store/OriginalItem';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class CollaboGoodsEtcList extends PureComponent {
  state = {
    gotoPage: 1,
    pageSize: 8,
    pageCount: 0,
    con: 0,
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props.match.params.idx !== nextProps.match.params.idx;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.match.params.idx !== nextProps.match.params.idx) {
      this._getData(1);
    }
  };
  _getData = async (gotoPage) => {
    const result = await this._getDataApi(gotoPage);
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const intReturn = result.data[0].intReturn;
    const goodsList = result.data[0].listData;

    //console.log(gotoPage, pageCount, con)

    if (intReturn === 0) {
      if (con > 0) {
        if (this._isLoad) {
          this.setState({
            goodsList:
              gotoPage === 1
                ? goodsList
                : this.state.goodsList.concat(goodsList),
            con,
            pageCount,
            gotoPage,
          });
        }
      } else {
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl } = this.props;
    const { pageSize } = this.state;
    return axios
      .post(apiUrl + '/collaboEtcGoods', {
        params: {
          gotoPage: gotoPage,
          pageSize: pageSize,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { goodsList } = this.state;

    const list = goodsList.map((item, index) => {
      return (
        <OriginalItem
          key={index}
          goodSerial={item.goodSerial}
          goodTitle={item.goodTitle}
          saleType={item.saleType}
          saleEnd={item.saleEnd}
          dcPrice={item.dcPrice}
          price={item.price}
          good_Img={item.good_Img}
          goodsType={item.goodsType}
          SaleActive={item.SaleActive}
          type={'collabo'}
        />
      );
    });

    return list;
  };
  _more = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 < pageCount) {
      this._getData(gotoPage + 1);
    } else {
      toast.warn('페이지의 마지막입니다.');
    }
  };
  render() {
    const { pageCount, gotoPage, goodsList } = this.state;
    return (
      <Fragment>
        <div className="store_newsStory">
          {/* 타이틀 */}
          {goodsList ? (
            <>
              <div className="store_con_tit">
                <h2>콜라보 굿즈 온라인 판매</h2>
                <div className="sub">
                  고객님들의 사랑을 많이 받았던 인기상품들에 한해 온라인에서
                  판매중입니다.
                </div>
              </div>

              <ul className="store_card_list">
                <li className="store_card_item sm_item only">
                  {/* only 추가 220118 */}
                  <div className="inner_item">
                    {/* 카드 내용 오리지널 굿즈 orgin */}
                    {this._renderItem()}
                  </div>

                  <button className="btn_loadMore" onClick={this._more}>
                    LOAD MORE
                    <span className="num">
                      ( <b>{gotoPage}</b> / {pageCount} )
                    </span>
                  </button>
                </li>
              </ul>
            </>
          ) : (
            <div className="store_con_tit">
              <h2>콜라보 굿즈의 온라인 판매가 준비중입니다.</h2>
              <div className="sub"></div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(CollaboGoodsEtcList)));
